module.exports = __webpack_public_path__ + "img/animazione-bimbi-classic.a97302ae.jpg";